module.exports = __webpack_public_path__ + "img/sessionImage.d4388d4a.png";